import { TKeyAdmin } from "./keys/TKeyAdmin";
import { TKeyAffiliation } from "./keys/TKeyAffiliation";
import { TKeyApp } from "./keys/TKeyApp";
import { TKeyAuth } from "./keys/TKeyAuth";
import { TKeyBlog } from "./keys/TKeyBlog";
import { TKeyBrand } from "./keys/TKeyBrand";
import { TKeyCallAnalysis } from "./keys/TKeyCallAnalysis";
import { TKeyClientAvatar } from "./keys/TKeyClientAvatar";
import { TKeyCommon } from "./keys/TKeyCommon";
import { TKeyCompany } from "./keys/TKeyCompany";
import { TKeyCompetition } from "./keys/TKeyCompetition";
import { TKeyContentCreation } from "./keys/TKeyContentCreation";
import { TKeyCredits } from "./keys/TKeyCredits";
import { TKeyEmails } from "./keys/TKeyEmails";
import { TKeyErrors } from "./keys/TKeyErrors";
import { TKeyExtension } from "./keys/TKeyExtension";
import { TKeyFAQ } from "./keys/TKeyFAQ";
import { TKeyFields } from "./keys/TKeyFields";
import { TKeyFooter } from "./keys/TKeyFooter";
import { TKeyHeader } from "./keys/TKeyHeader";
import { TKeyHome } from "./keys/TKeyHome";
import { TKeyHomeMeidly } from "./keys/TKeyHomeMeidly";
import { TKeyJobs } from "./keys/TKeyJobs";
import { TKeyMarketAnalysis } from "./keys/TKeyMarketAnalysis";
import { TKeyMcp } from "./keys/TKeyMcp";
import { TKeyMessagesContent } from "./keys/TKeyMessagesContent";
import { TKeyNavigation } from "./keys/TKeyNavigation";
import { TKeyOffer } from "./keys/TKeyOffer";
import { TKeyPrivacy } from "./keys/TKeyPrivacy";
import { TKeyProjectMember } from "./keys/TKeyProjectMember";
import { TKeyProjects } from "./keys/TKeyProjects";
import { TKeyProspectRecord } from "./keys/TKeyProspectRecord";
import { TKeyProspectSearch } from "./keys/TKeyProspectSearch";
import { TKeySalesScript } from "./keys/TKeySalesScript";
import { TKeySettings } from "./keys/TKeySettings";
import { TKeyTerms } from "./keys/TKeyTerms";

export const TKey = {
  ...TKeyAdmin,
  ...TKeyAffiliation,
  ...TKeyApp,
  ...TKeyAuth,
  ...TKeyBlog,
  ...TKeyBrand,
  ...TKeyCallAnalysis,
  ...TKeyClientAvatar,
  ...TKeyCommon,
  ...TKeyCompany,
  ...TKeyCompetition,
  ...TKeyContentCreation,
  ...TKeyCredits,
  ...TKeyEmails,
  ...TKeyErrors,
  ...TKeyExtension,
  ...TKeyFAQ,
  ...TKeyFields,
  ...TKeyFooter,
  ...TKeyHeader,
  ...TKeyHome,
  ...TKeyHomeMeidly,
  ...TKeyJobs,
  ...TKeyMarketAnalysis,
  ...TKeyMcp,
  ...TKeyMessagesContent,
  ...TKeyNavigation,
  ...TKeyOffer,
  ...TKeyPrivacy,
  ...TKeyProjectMember,
  ...TKeyProjects,
  ...TKeyProspectRecord,
  ...TKeyProspectSearch,
  ...TKeySalesScript,
  ...TKeySettings,
  ...TKeyTerms,
} as const;

export type TKey = (typeof TKey)[keyof typeof TKey];
